// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p[data-v-32303cdf]{color:#fff;font-size:16px}.cv-header.bx--header[data-v-32303cdf]{position:relative;background-color:#393939;height:48px;z-index:1}.cv-header-name.bx--header__name[data-v-32303cdf]{border-right:1px solid #000;padding:16px;margin-right:10px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
